import "packages/frontend/core/src/desktop/dialogs/setting/general-setting/billing/style.css.ts.vanilla.css!=!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"packages/frontend/core/src/desktop/dialogs/setting/general-setting/billing/style.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA7VWwY7aMBC98xWuqkrdg1FCWRa8Ug/9EyeeJF4S27UnC7Tqv1dxIOtACLDsXoiIPTPvzbyZzBQ361UWxeTvhBAhnSn5jpGshO3zhPgnFdJCilIrRlJd1pVqTngpc0UlQuUYSUEh2OZ1zg0js7nZPk/+Taat75n3vZECC0biKPoWnP0YjvtSO5TZjqZaIShkxBmeAk0ANwA+vuFCSJUzEs+MN0m0FWAZic2WOF1KQV65/U4pzzKpgL7OaMl3YKlUTgr45W/T1ujhzZ5aLmTtGFn2KMw9zAYdIzGJSBScPY6kbmObfDS/XXKWLdyK21wqitocx1qE6eI1avJFVkZb5AqDa08tJK2QOvkHWJ+uf1/Qhafm/2xA5gUysohC8MvLXhLu4CEwWXmTEH9Xb8FVDlbXjjpAlConU8Ur8AapLrVlJ0VxyLF2FKzVNozCx4wQtkgdpFoJbndvHM9R2LrQdXKZszc4Stxjk7hhSB4PVKbgTjrqb3j7tLauuWy0bBukw5De2m9DjSVudVJJRYs9nad935xp5JMOPBx10eG9rbuXTqIRdXWs/uxycVx1RtWElM2lA8PZnuGYiIyVVSuhDkF+tTz60aI2Wg/W/LxmhmQcYPhJzndAYrkSgcxOZdo5Ku6a66BE4EseJyZeDlAerMTiXZV4+cBKjHTvaCXWwwkc+/zFi56iy7sUfV3KBpXfIaiGOXiw89HKJDWiVkO1qaaGO6SiHp3ue/uT6a7uGMGdE93bK/ZEDimI+6PSnHy0+t/hEjI87BKd0e/bax92xKdVuwNoPcCEp+vc6vowExj5GkfJahkHHjeFROjtTTOzPaA9Wn3mV3C4XB0X6iIAdNOugR+/BfwHmQvLnPEKAAA=\"}!../../../../../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var believerHeader = 'twk9f0e';
export var believerPrice = 'twk9f0i';
export var believerPriceCaption = 'twk9f0j';
export var believerPriceWrapper = 'twk9f0h';
export var believerSubtitle = 'twk9f0g';
export var believerTitle = 'twk9f0f';
export var billingFrequency = 'twk9f08';
export var billingHistorySkeleton = 'twk9f0d';
export var cardLabel = 'twk9f0n';
export var cardLabelContainer = 'twk9f0m';
export var cardLabelIcon = 'twk9f0o';
export var cardName = 'twk9f0l';
export var cardNameLabelRow = 'twk9f0k';
export var currentPlan = 'twk9f04';
export var currentPlanHeader = 'twk9f0q';
export var currentPlanName = 'twk9f0b';
export var history = 'twk9f01';
export var historyContent = 'twk9f02';
export var lifetimeBadge = 'twk9f0r';
export var lifetimeLabel = 'twk9f0s';
export var manageMentInCard = 'twk9f0p';
export var noInvoice = 'twk9f0a';
export var paymentMethod = 'twk9f09';
export var planAction = 'twk9f06';
export var planActions = 'twk9f05';
export var planCard = 'twk9f03';
export var planPrice = 'twk9f07';
export var storageInfo = 'twk9f0t';
export var subscription = 'twk9f00';
export var subscriptionSettingSkeleton = 'twk9f0c';